import React from "react";
import LojaModel from "./model/LojaModel";
import ReactDOM from "react-dom";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { compose, withProps } from "recompose";
import MockData from "./model/MockData";
import AppState from "./model/AppState";
import C5LojaDAO from "./dataAccess/C5/C5LojaDAO";
import ProxyDistanciaDAO from "./dataAccess/Proxy/ProxyDistanciaDAO";
import QueryString from "query-string";
import { FormControl, Snackbar } from "@material-ui/core";
import InputMask from "react-input-mask";
import NavegadorUtil from "./util/NavegadorUtil";
import LogUtil from "./util/LogUtil";
import C5CarrinhoDAO from "./dataAccess/C5/C5CarrinhoDAO";
import Carregando from "./components/Carregando";
import CarrinhoModel from "./model/CarrinhoModel";
import { RouteComponentProps, withRouter } from "react-router-dom";
import StringUtil from "./util/StringUtil";
import ObaTextField from "./components/ObaTextField";
import LocalizacaoModel from "./model/LocalizacaoModel";
import { getDistance } from "geolib";
import LojaDistanciaModel from "./model/LojaDistanciaModel";
import { FilterOptionsState } from "@material-ui/lab/useAutocomplete";
import C5UsuarioDAO from "./dataAccess/C5/C5UsuarioDAO";
import C5UsuarioEnderecoModel from "./model/C5UsuarioEnderecoModel";
import UsuarioModel from "./model/UsuarioModel";
import ModalNewApp from "./components/ModalNewApp";
import ProxyConfiguracaoDAO from "./dataAccess/Proxy/ProxyConfiguracaoDAO";
import ObaNotificacaoModel from "./model/ObaNotificacaoModel";
import ClearCache from "react-clear-cache";


const GMapsComponent: any = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBSQUKL5iuARGYa1Mz8NJlGngyLZ4jqn4c&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ minHeight: `77vh` }} />,
  }),
  withScriptjs,
  withGoogleMap,
  withRouter
)((props: any) => {
  const icoImage: string = "assets/images/icons/marker.svg";
  const icoImageApp: string = "assets/images/icons/marker-app.png";
  let { lojas, localizacao, filtroLojaApp, filtroLojaFisica } = props;
  let zoom: number = 12;

  if (isNaN(localizacao.lat)) {
    localizacao = { lat: -22.851887200000004, lng: -47.145969199999996 };
  } else {
    zoom = localizacao.zoom;
  }

  return (
    <GoogleMap
      zoom={zoom}
      center={localizacao}
      defaultOptions={{ disableDefaultUI: true }}
    >
      {lojas &&
        lojas.length > 0 &&
        lojas
          .filter(
            (loja: LojaModel) =>
              loja.latitude &&
              loja.longitude &&
              (loja.latitude !== 0 || loja.longitude !== 0)
          )
          .filter(
            (loja: LojaModel) =>
              (filtroLojaApp && loja.retirada) ||
              (filtroLojaFisica && !loja.retirada)
          )
          .map((loja: LojaModel) => (
            <Marker
              position={{ lat: loja.latitude, lng: loja.longitude }}
              icon={loja.retirada ? icoImageApp : icoImage}
              key={loja.lojaId}
              onClick={async () => {
                await AppState.setLojaSelecionada(loja);
                let query: any;
                if (props.location && props.location.search) {
                  query = QueryString.parse(props.location.search);
                  if (query.returnUrl) {
                    NavegadorUtil.redirect(query.returnUrl, props.history);
                  } else {
                    NavegadorUtil.redirect(`/home`, props.history);
                  }
                } else {
                  NavegadorUtil.redirect(`/home`, props.history);
                }
              }}
            ></Marker>
          ))}
    </GoogleMap>
  );
});

interface ILojaProps extends RouteComponentProps {}

type LojaState = {
  lojas: LojaModel[];
  todasLojas: LojaModel[];
  endereco: string;
  localizacaoBase: any;
  geolocalizado: boolean;
  carregando: boolean;
  concluido: boolean;
  filtroLojaFisica: boolean;
  filtroLojaApp: boolean;
  filtroPertoDeMim: boolean;
  estado: string;
  cep: string;
  lojaDelivery: boolean;
  lojaRetirada: boolean;
  consultouCEP: boolean;
  usuarioEndereco: C5UsuarioEnderecoModel | null;
  lojasFiltradas: LojaModel[];
  modalNewAppVisivel: boolean;
  notificacao: ObaNotificacaoModel | null;
};

class Loja extends React.Component<ILojaProps, LojaState> {
  constructor(props: ILojaProps) {
    super(props);

    this.fecharModalNewApp = this.fecharModalNewApp.bind(this);

    this.state = {
      lojas: [],
      endereco: "",
      localizacaoBase: {},
      geolocalizado: false,
      carregando: false,
      concluido: false,
      filtroLojaApp: true,
      filtroLojaFisica: true,
      filtroPertoDeMim: false,
      estado: "",
      cep: "",
      lojaDelivery: false,
      lojaRetirada: false,
      consultouCEP: false,
      usuarioEndereco: null,
      todasLojas: [],
      lojasFiltradas: [],
      modalNewAppVisivel: true,
      notificacao: null,
    };
    this.mostrarLojas = this.mostrarLojas.bind(this);
    this.mostrarMapa = this.mostrarMapa.bind(this);
    this.setLoja = this.setLoja.bind(this);
    this.getLojasProximas = this.getLojasProximas.bind(this);
    this.obterDistancias = this.obterDistancias.bind(this);
    this.filterOptions = this.filterOptions.bind(this);
    this.filtroLojas = this.filtroLojas.bind(this);
    this.filtroLojasApp = this.filtroLojasApp.bind(this);
    this.validaCEP = this.validaCEP.bind(this);
    this.setDelivery = this.setDelivery.bind(this);
    this.setRetirada = this.setRetirada.bind(this);
    this.posFiltroTipo = this.posFiltroTipo.bind(this);
  }

  async componentDidMount(): Promise<any> {
    LogUtil.logPage("Lojas");

    let lojas: LojaModel[];
    AppState.setMockData(false);

    if (AppState.getMockData()) {
      lojas = MockData.getLojas();
      this.setState({ lojas });
    } else {
      C5LojaDAO.getInstance()
        .getAll()
        .then((lojas: LojaModel[]) => {
          this.setState({ lojas, todasLojas: lojas, concluido: true });
        });

      try {
        let modais = await ProxyConfiguracaoDAO.getInstance().getModalData();
        modais = modais.filter(m => m.disponivelDe > new Date() && m.disponivelAte < new Date());

        if (modais.length > 0) {
          this.setState({ notificacao: modais[0] });
        }
      } catch (ex) {
        LogUtil.logEvento('NotificacaoErro', ex);
      }

      const logado: UsuarioModel | null = AppState.getUsuarioLogado();
      if (logado) {
        if (logado && logado.cep.length > 1) {
          await this.validaCEP(logado.cep.padStart(8, "0"));
          this.setDelivery();
        }
      }
    }
    setTimeout(() => {
      let query: any;
      query = QueryString.parse(this.props.location.search);
      if (query.geolocalizar === "true") {
        this.getLojasProximas();
      }
    }, 3000);
  }

  setEstado(uf: string): void {
    this.setState({ estado: uf });
  }

  async setLoja(loja: LojaModel): Promise<any> {
    this.setState({ carregando: true });

    const lojaAnterior: LojaModel | null = AppState.getLojaSelecionada();
    if (lojaAnterior && lojaAnterior.lojaId !== loja.lojaId) {
      const carrinho: CarrinhoModel = AppState.getCarrinho();
      if (carrinho.carrinhoItens.length > 0) {
        NavegadorUtil.alertaModal(
          `A Alteração de loja pode ter afetado a quantidade e disponibilidade de itens em seu carrinho`
        );
      }
    }

    await AppState.setLojaSelecionada(loja);

    C5CarrinhoDAO.getInstance()
      .updateCarrinho(loja)
      .then(() => {
        let query: any;
        query = QueryString.parse(this.props.location.search);
        if (query.returnUrl) {
          this.props.history.push(query.returnUrl);
        } else {
          this.props.history.push(`/home`);
        }
      });
  }

  mostrarLojas(): any {
    const mapa: any = this.refs.btnMap;
    const lista: any = this.refs.btnList;

    if (mapa) {
      mapa.classList.remove("active");
    }

    if (lista) {
      lista.classList.remove("active");
      lista.classList.add("active");
    }

    const mapsContainer: any = ReactDOM.findDOMNode(this.refs.mapsContainer);
    const storesContainer: any = ReactDOM.findDOMNode(
      this.refs.storesContainer
    );
    mapsContainer.style.display = "none";
    storesContainer.style.display = "block";
  }

  mostrarMapa(): any {
    const mapa: any = this.refs.btnMap;
    const lista: any = this.refs.btnList;
    if (mapa) {
      mapa.classList.remove("active");
      mapa.classList.add("active");
    }

    if (lista) {
      lista.classList.remove("active");
    }

    const mapsContainer: any = ReactDOM.findDOMNode(this.refs.mapsContainer);
    const storesContainer: any = ReactDOM.findDOMNode(
      this.refs.storesContainer
    );
    mapsContainer.style.display = "block";
    storesContainer.style.display = "none";
  }

  public getLojasProximas(): void {
    const { endereco } = this.state;

    if (navigator.geolocation) {
      this.setState({ carregando: true });
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (endereco && endereco.length > 3) {
            this.obterDistancias(endereco, false);
          } else {
            this.obterDistancias(
              `${position.coords.latitude},${position.coords.longitude}`, true
            );
          }

          this.setState({ filtroPertoDeMim: true, cep: '' });
        },
        (error) => {
          if (endereco.length < 10) {
            NavegadorUtil.alerta(this, `A geolocalização está desativada! Favor ativar e tentar novamente.`);
            this.setState({ carregando: false, concluido: true, filtroPertoDeMim: false });
          } else {
            NavegadorUtil.alerta(this, `A geolocalização está desativada! Favor ativar e tentar novamente.`);
            this.setState({ carregando: false, concluido: true });
            this.obterDistancias(endereco, false);
          }
        },
        { enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0 }
      );
    } else {
      NavegadorUtil.alerta(this, "A geolocalização está desativada! Favor ativar e tentar novamente.");
      this.setState({ carregando: false, concluido: true });
    }
  }

  async validaCEP(cep: string): Promise<any> {
    this.setState({ cep });
    const cepTratado: string = cep.replace(/-/g, "").replace(/_/g, "");

    if (cepTratado.length === 8) {
      this.setState({ carregando: true });
      return C5UsuarioDAO.getInstance()
        .buscaCep(cepTratado)
        .then(async (r) => {
          this.setState({
            consultouCEP: true,
            usuarioEndereco: r,
            filtroPertoDeMim: false,
          });

          const enderecoCompleto: string = `${r.StreetAddress} - ${r.Neighborhood} - ${r.City} - ${r.State}`;

          const localizacao: LocalizacaoModel = await ProxyDistanciaDAO.getInstance().getLocalizacao(
            enderecoCompleto
          );

          const lojas: LojaModel[] = await C5LojaDAO.getInstance().getAll();
  
          let lojasDistancias: LojaDistanciaModel[] = lojas.map(
            (loja) => {
              const distancia: number = getDistance(localizacao, loja);

              let maiorRaio = loja.raioAtuacao;

              for (const raioAtuacao of loja.raiosAtuacao) {
                maiorRaio = raioAtuacao.Distancia;
              }

              return {
                loja,
                distancia: distancia,
                delivery: distancia <= maiorRaio,
              } as LojaDistanciaModel;
            }
          ).sort(LojaDistanciaModel.sort);

          if (this.state.lojaDelivery) {
            lojasDistancias = lojasDistancias.filter(l => l.delivery);
          }

          this.setState({
            lojasFiltradas: lojasDistancias.filter((l) => l.delivery).map(l => l.loja),
            lojas: lojasDistancias.map(l => l.loja),
            todasLojas: lojasDistancias.map(l => l.loja),
            carregando: false,
            concluido: true,
          }, () => {
            this.setDelivery();
          });
        }).catch((ex) => {
          NavegadorUtil.alerta(this, "CEP não encontrado");
          this.setState({ carregando: false, concluido: true });
        });
    }
  }

  public async obterDistancias(endereco: string, geolocalizado: boolean): Promise<void> {
    
    const { todasLojas, filtroLojaApp, filtroLojaFisica } = this.state;

    const destinos: LojaModel[] = todasLojas
      .filter(
        (loja: LojaModel) =>
          (filtroLojaApp && loja.retirada) ||
          (filtroLojaFisica && !loja.retirada)
      );

    this.setState({ carregando: true });

    let localizacao: LocalizacaoModel;

    if (geolocalizado) {
      localizacao = {
        latitude: +endereco.split(',')[0],
        longitude: +endereco.split(',')[1],
        location: "",
        city: "",
        state: ""
      } as LocalizacaoModel;
    } else {
      try {
        if (endereco.indexOf(',') === -1) {
          endereco += ',10';
        }
        
        localizacao = await ProxyDistanciaDAO.getInstance().getLocalizacao(
          endereco
        );
      } catch (ex) {
        LogUtil.logObject(ex, typeof ex);
        NavegadorUtil.alerta(this, "Endereço não localizado.  Favor informar tipo de logradouro, logradouro, número, bairro, cidade e estado. Ex: 'Av. Getulio Vargas, 123, São Paulo, SP'");
        this.setState({ carregando: false, concluido: true });
        return;
      }

      if (localizacao.latitude === 0 || localizacao.longitude === 0) {
        NavegadorUtil.alertaModal("Endereço não localizado.  Favor informar tipo de logradouro, logradouro, bairro, cidade e estado.");
        return;
      }
    }

    let lojasDistancias: LojaDistanciaModel[] = destinos.map(
      loja => {
        const distancia: number = getDistance(localizacao, loja);

        return {
          loja,
          distancia: distancia,
          delivery: distancia <= loja.raioAtuacao,
        } as LojaDistanciaModel;
      }
    );

    if (this.state.lojaDelivery) {
      lojasDistancias = lojasDistancias.filter(l => l.delivery);
    }

    lojasDistancias = lojasDistancias
      .sort(LojaDistanciaModel.sort);

    const lojasOrdenadas: LojaModel[] = [];
    let i:number = 0;
    lojasDistancias.forEach(lojaDistancia => {
      lojaDistancia.loja.ordemExibicao = ++i;
      lojasOrdenadas.push(lojaDistancia.loja); 
    });

    this.setState({
      lojasFiltradas: lojasDistancias.filter(l => l.delivery).map(l => l.loja),
      lojas: lojasOrdenadas,
      localizacaoBase: { lat: localizacao.latitude, lng: localizacao.longitude },
      carregando: false,
      concluido: true,
    });
  }

  filterOptions(lojasOpcoes: LojaModel[], q: FilterOptionsState<LojaModel>): LojaModel[] {
    return lojasOpcoes.filter(
      (l) =>
        StringUtil.sanitize(l.nome).indexOf(q.inputValue) > -1 ||
        StringUtil.sanitize(l.logradouro).indexOf(q.inputValue) > -1
    );
  }

  filtroLojas(): void {
    this.setState({ filtroLojaFisica: !this.state.filtroLojaFisica }, () => {
      if (!this.state.filtroLojaApp && !this.state.filtroLojaFisica) {
        this.setState({ filtroLojaApp: true, filtroLojaFisica: true });
      }
    });
  }

  filtroLojasApp(): void {
    this.setState({ filtroLojaApp: !this.state.filtroLojaApp }, () => {
      if (!this.state.filtroLojaApp && !this.state.filtroLojaFisica) {
        this.setState({ filtroLojaApp: true, filtroLojaFisica: true });
      }
    });
  }

  setDelivery(): void {
    
    AppState.setModalidadeEntregaCompra("delivery");

    if (this.state.lojaDelivery) return;
    
    this.setState({ 
      lojaDelivery: !this.state.lojaDelivery,
      lojaRetirada: false,
      lojas: this.state.lojaDelivery ? this.state.lojasFiltradas : this.state.todasLojas
    }, this.posFiltroTipo);
  }
  
  setRetirada(): void {

    AppState.setModalidadeEntregaCompra("retirada");

    const { lojaRetirada, todasLojas } = this.state;
    
    if (lojaRetirada) return;

    this.setState({
      lojaRetirada: !lojaRetirada,
      lojaDelivery: false,
      lojas: todasLojas
    }, this.posFiltroTipo);
  }

  posFiltroTipo(): void {
    const { lojaDelivery, consultouCEP, filtroPertoDeMim } = this.state;
    if (lojaDelivery) {
      if (!filtroPertoDeMim && !consultouCEP) {
        NavegadorUtil.alerta(this, "Para mostrar as lojas disponíveis no delivery use a opção 'Usar minha localização' ou informe um cep.");
      } else {
        this.setState({ lojas: this.state.lojasFiltradas });
      }
    }
  }

  fecharModalNewApp(): any {
    this.setState({ modalNewAppVisivel: false });
  }
  
  render(): any {
    const {
      lojas,
      localizacaoBase,
      geolocalizado,
      carregando,
      concluido,
      filtroLojaApp,
      filtroLojaFisica,
      filtroPertoDeMim,
      estado,
      cep,
      lojaDelivery,
      lojaRetirada,
      modalNewAppVisivel,
      notificacao,
    } = this.state;
    let alerta: any = AppState.getAlerta();

    return (
      <section className="escolha-loja">
        <ClearCache>
          {(props: any) => {
            console.log(props);
            if (!props.isLatestVersion) {
              props.emptyCacheStorage();
            }
            return null;
          }}
        </ClearCache>

        <div className="container">
          <div className="header">
            <div className="title">
              <img src={ `${process.env.PUBLIC_URL}/assets/images/oba-hortifruti.png` } alt=""/>
              <p>
                Use sua localização ou forneça seu CEP para encontrar uma loja.
              </p>
            </div>
            <button 
              onClick={() => { if(!filtroPertoDeMim) this.getLojasProximas(); } }
              className={`btn ${filtroPertoDeMim ? "active" : ""}`}
            >
              <i className="fas fa-location-arrow"></i> {filtroPertoDeMim ? "Usando minha localização" : "Usar minha localização"}
            </button>
            <div className="search-cep">
              <FormControl variant="outlined">
                  <InputMask
                    mask="99999-999"
                    maskChar="_"
                    value={cep}
                    onChange={(e) => this.validaCEP(e.target.value as string)}
                  >
                    {(inputProps: any) => (
                      <ObaTextField
                        {...inputProps}
                        variant="outlined"
                        label="Digite seu CEP"
                      ></ObaTextField>
                    )}
                  </InputMask>
                </FormControl>
              <i className="fas fa-map-marker-alt"></i>
            </div>
          </div>
          <div className="search">
            <Autocomplete
              options={lojas}
              getOptionLabel={(o: LojaModel) => `Loja ${o.nome}`}
              filterOptions={this.filterOptions}
              noOptionsText="Nenhuma loja encontrada na lista com o endereço indicado.  Caso este seja seu endereço, clique em Ir para prosseguir com a busca para o endereço informado."
              renderInput={(params) => (
                <ObaTextField
                  {...params}
                  variant="outlined"
                  label="Escolha uma loja ou digite seu endereço"
                  margin="normal"
                  fullWidth
                />
              )}
              onChange={(e: any, value: any) => {
                if (value) {
                  this.setLoja(value);
                }
              }}
              onKeyUp={(e: any) => {
                if (e.key === "Enter") {
                  this.getLojasProximas();
                  e.target.blur();
                } else {
                  if ((e.target.value as string).length > 0) {
                    this.setState({ endereco: e.target.value as string });
                  }
                }
              }}
              onClose={(e: any) => {
                this.getLojasProximas();
                e.target.blur();
              }}
            ></Autocomplete>
            <div className="btn-group">
              <button
                className={lojaDelivery ? 'active' : ''}
                onClick={ this.setDelivery } >
                  Delivery
              </button>
              <button
                className={lojaRetirada ? 'active' : ''}
                onClick={ this.setRetirada } >
                  Retirada
              </button>
            </div>
          </div>
          { false && (
            <ul className="main-menu">
              <li
                className="list active"
                ref="btnList"
                onClick={this.mostrarLojas}
              >
                <i className="fas fa-list-ul"></i> Lista
              </li>
              <li className="maps" ref="btnMap" onClick={this.mostrarMapa}>
                <i className="far fa-map"></i> Mapa
              </li>
            </ul>
          )}
        </div>
        <div id="maps" ref="mapsContainer">
          <div className="floater">
            <button
              onClick={() => this.setEstado( estado === 'DF' ? "" : "DF" )}
              className={`filtro ${estado === 'DF' ? "" : "inactive"}`}
            >DF</button>
            <button
              onClick={() => this.setEstado( estado === 'GO' ? "" : "GO" )}
              className={`filtro ${estado === 'GO' ? "" : "inactive"}`}
            >GO</button>
            <button
              onClick={() => this.setEstado( estado === 'SP' ? "" : "SP" )}
              className={`filtro ${estado === 'SP' ? "" : "inactive"}`}
            >SP</button>
            <button 
              onClick={this.getLojasProximas}
              className={`filtro ${filtroPertoDeMim ? "" : "inactive"}`}
            >
              <i className="fas fa-location-arrow"></i>&nbsp;&nbsp;Perto de mim
            </button>
          </div>
          {localizacaoBase && !Number.isNaN(localizacaoBase.lat) && (
            <GMapsComponent
              filtroLojaFisica={filtroLojaFisica}
              filtroLojaApp={filtroLojaApp}
              lojas={lojas.filter((loja) => estado.length === 0 || (loja.uf.toLowerCase() === estado.toLowerCase()))}
              estado={estado}
              localizacao={localizacaoBase}
              geolocalizado={geolocalizado}
            ></GMapsComponent>
          )}
        </div>
        { lojaDelivery &&
        <div className="stores-alerts">
          <p><strong>Para delivery o valor mínimo é de R$150,00</strong></p>
          { lojas.length === 0 &&
            <p>Não há lojas com delivery neste endereço. <br /><strong>Escolha uma loja para retirada</strong></p>
          }
        </div>
        }
        <div id="stores" ref="storesContainer">
          <div className="floater">
            <button
              onClick={() => this.setEstado( estado === 'DF' ? "" : "DF" )}
              className={`filtro ${estado === 'DF' ? "" : "inactive"}`}
            >DF</button>
            <button
              onClick={() => this.setEstado( estado === 'GO' ? "" : "GO" )}
              className={`filtro ${estado === 'GO' ? "" : "inactive"}`}
            >GO</button>
            <button
              onClick={() => this.setEstado( estado === 'SP' ? "" : "SP" )}
              className={`filtro ${estado === 'SP' ? "" : "inactive"}`}
            >SP</button>
            <button 
              onClick={this.getLojasProximas}
              className={`filtro ${filtroPertoDeMim ? "" : "inactive"}`}
            >
              <i className="fas fa-location-arrow"></i>&nbsp;&nbsp;Perto de mim
            </button>
          </div>
          <ul>
            {lojas
              .sort((a: LojaModel, b: LojaModel) => {
                return a.ordemExibicao < b.ordemExibicao ? -1 : 1;
              })
              .filter(
                (loja) => estado.length === 0 || (loja.uf.toLowerCase() === estado.toLowerCase())
              )
              .filter(
                (loja) =>
                  (filtroLojaApp && loja.retirada) ||
                  (filtroLojaFisica && !loja.retirada)
              )
              .map((loja: LojaModel) => (
                <li key={loja.lojaId} onClick={() => this.setLoja(loja)}>
                  <p className="title">{loja.nome}</p>
                  <p>
                    {loja.logradouro}, {loja.numero},{" "}
                    {loja.cidade} - {loja.uf} {loja.cep ? ', '+loja.cep : ''}
                  </p>
                  {loja.telefones && <p>Telefone: {loja.telefones}</p>}
                  <p className="store-hours">
                    {loja.retirada && (
                      <>
                        <i className="fas fa-mobile-alt"></i>&nbsp;&nbsp;
                        <span>Aceita compra pelo app</span>
                      </>
                    )}
                    {!loja.retirada && (
                      <>
                        <i className="fas fa-store-alt"></i>&nbsp;&nbsp;
                        <span>Somente compra na loja física</span>
                      </>
                    )}
                  </p>
                </li>
              ))}
          </ul>
        </div>
        <Carregando exibir={carregando} concluido={concluido} />
        {alerta && (
          <Snackbar
            open={alerta.exibirModal}
            className="info"
            transitionDuration={1000}
            onClose={() => AppState.fecharAlerta(this)}
            autoHideDuration={6000}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
            message={<span id="message-id">{alerta.mensagem}</span>}
          />
        )}
        { window.innerWidth < 600 && notificacao &&
        <ModalNewApp
          notificacao={notificacao}
          fechar={this.fecharModalNewApp}
          visivel={modalNewAppVisivel}
        />
        }
      </section>
    );
  }
}

export default withRouter(Loja);
